export default "__VITE_ASSET__CRCFKLkl__"